var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.753 19.999q-.53 0-.888-.36a1.2 1.2 0 0 1-.359-.89v-7.5L.275 1.999Q-.192 1.374.135.687t1.137-.688h17.455q.81 0 1.139.688.325.687-.141 1.312l-7.232 9.25v7.5q0 .53-.357.89-.36.36-.89.36z"
})));
export default SvgFilter;